import React from "react"
import { observer } from "mobx-react"

import {GridDataEntry} from "controls/grid/gridDataEntry"
import { AntAlert } from "controls/react/ant/antAlert"
import { ApplicationState } from "framework/applicationState"
import {getStore, GridStoreHolder} from "controls/grid/utils/getStore";


const i = require('core/localization/localization').translator({
	"External filter applied. Click to go to default view": {
		no: "Eksternt filter satt. klikk for å gå til standardvisning"
	},
	'Click here to clear the filter':{
		no: 'Klikk her for å fjerne filteret'
	},
	"Tags are active": {
		"no": "Etiketter er aktive"
	  },
	  "Tags are active and content is filtered": {
		"no": "Etiketter er aktive og innholdet er filtrert"
	  },
});

type GridFilteredIndicator<T extends GridDataEntry> = {
	store: GridStoreHolder<T>
	forceFilteredState?: boolean
	onForcedFilterClick?: () => void
}

export const GridFilteredIndicator = observer(<T extends GridDataEntry,>(props: GridFilteredIndicator<T>) => {
	const store = getStore(props.store)

	if (store?.selfInitialized != true)
		return null

	if ((!store.filtered && !store.state.currentView.isTemporary()) && !ApplicationState.tagsEnabled && !props.forceFilteredState)
		return null;

	let onClick: () => void, message: React.ReactNode;

	if (props.forceFilteredState) {
		message = <div title={i('Click here to clear the filter')}>{i('Content is filtered')}</div>
		onClick = props.onForcedFilterClick
	}else if (store.state.currentView.isTemporary()) {
		onClick = () => store.state.switchToDefaultView()
		message = i('External filter applied. Click to go to default view')
	} else if (ApplicationState.tagsEnabled) {
		if (store.filtered) {
			onClick = () => store.clearFilters();
			message = i('Tags are active and content is filtered')
		} else {
			message = i('Tags are active')
			onClick = () => {
				store.clearFilters()
			}
		}
	} else if (store.filtered) {
		onClick = () => store.clearFilters();
		message = <div title={i('Click here to clear the filter')}>{i('Content is filtered')}</div>
	}
	return <AntAlert type={"info"}
					 showIcon={true}
					 message={message}
					 onClick={onClick}/>
})
